import { render, staticRenderFns } from "./SectionInfo.vue?vue&type=template&id=2c262a47&scoped=true"
import script from "./SectionInfo.vue?vue&type=script&lang=js"
export * from "./SectionInfo.vue?vue&type=script&lang=js"
import style0 from "./SectionInfo.vue?vue&type=style&index=0&id=2c262a47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c262a47",
  null
  
)

export default component.exports